import Vue from 'vue';
import axios from 'axios';
import VueAuth from '@websanova/vue-auth';
import VueAxios from 'vue-axios';
import routes from '@router/_bootstrap';
import auth from '@websanova/vue-auth/drivers/auth/bearer';
import http from '@websanova/vue-auth/drivers/http/axios.1.x';
import router from '@websanova/vue-auth/drivers/router/vue-router.2.x';
import { TOKEN_NAME } from '@constants/token';
import { API_BASE_URL } from '@constants/api';

// Vue router routes must be defined for the Vue Auth plugin
Vue.router = routes;

// Vue Axios is required for the Vue Auth plugin
Vue.use(VueAxios, axios);

// Define the API base entry URL
axios.defaults.baseURL = API_BASE_URL;

Vue.use(VueAuth, {
    auth,
    http,
    router,
    tokenDefaultName: TOKEN_NAME,
    refreshData: {
        enabled: false,
    },
    fetchData: {
        enable: false,
    },
});
